import client from "./client";
import { LoginSuccess, UserProfile } from "@/interfaces";
export const appLogin = (email: string, password: string) =>
  client.post<{ LoginResult: LoginSuccess }>("auth/login", { email, password });

export const getProfile = () => client.get<{ ProfileResult: UserProfile }>("profile");

export const getSSOToken = (token: string) => client.get<LoginSuccess>(`auth/tpt-sso/${token}`);
